import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPopoverSurfaceSeparatorProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";

const PopoverSurfaceSeparator: FC<IPopoverSurfaceSeparatorProps> = ({
    isHighlighted = false,
    customTheme,
    style,
    ...props
}) => {
    const {
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        separator: separatorDynamicStyle
    } = useStyles({
        isHighlighted,
        borders,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.separator,
            separatorDynamicStyle
        ]}
        role="separator"
    />;
};
export default PopoverSurfaceSeparator;
